module.exports = function() {
  return new Worker(__webpack_public_path__ + "27560f0bc4ba01a4ac2d.worker.js");
};